import React from "react";
import styles from "./BackgroundHTML.module.css";

function BackgroundJAVA() {
  return (
    <div className={styles.backgroundJAVA}>
      <pre>
        <span className={styles.classValue}>public class </span>
        <span>Main&#123;</span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <span className={styles.classValue}>public boolean </span>
        <span>
          hasCycle(<span className={styles.component}>ListNode</span>{" "}
          head)&#123;
        </span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
        <span>
          <span className={styles.component}>ListNode</span> fast
          <span className={styles.classValue}> = </span>head;
        </span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
        <span>
          <span className={styles.component}>ListNode</span> slow
          <span className={styles.classValue}> = </span>head;
        </span>
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span className={styles.classValue}>while</span>
        <span>
          ( fast<span className={styles.classValue}>!=</span>
          <span>null</span>
          <span className={styles.classValue}> &#38;&#38; </span>
          fast.next<span className={styles.classValue}>!=</span>
          <span>null</span>)&#123;
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fast
          <span className={styles.classValue}>=</span>fast.next.next;
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;slow
          <span className={styles.classValue}>=</span>slow.next;
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span className={styles.classValue}>if</span>
          (fast<span className={styles.classValue}>==</span>
          slow)
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span className={styles.classValue}>return </span>
          <span className={styles.class}>true</span>;<br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125;
          <br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span className={styles.classValue}>return </span>
          <span className={styles.class}>false</span>;<br />
          &nbsp;&nbsp;&nbsp;&nbsp;&#125;
          <br />
          &#125;
          <br />
        </span>
      </pre>
    </div>
  );
}

export default BackgroundJAVA;
